import React, { useState } from "react";
import { Card } from "react-bootstrap";
import { FiCalendar, FiSettings } from "react-icons/fi";

export default function MeetingsScheduleCard() {
  const [filter, setFilter] = useState("Today");
  const [open, setOpen] = useState(false);

  const allData = {
    Today: [
      {
        time: "09:25 AM",
        title: "Marketing Strategy Presentation",
        tag: "Marketing",
        color: "#f97316",
      },
      {
        time: "09:20 AM",
        title: "Design Review Hospital, doctors Management Project",
        tag: "Review",
        color: "#0f172a",
      },
      {
        time: "09:18 AM",
        title: "Birthday Celebration of Employee",
        tag: "Celebration",
        color: "#facc15",
      },
      {
        time: "09:10 AM",
        title: "Update of Project Flow",
        tag: "Development",
        color: "#22c55e",
      },
    ],

    "This Month": [
      {
        time: "10:00 AM",
        title: "Monthly Planning Meeting",
        tag: "Planning",
        color: "#3b82f6",
      },
    ],

    "This Year": [
      {
        time: "11:00 AM",
        title: "Annual Strategy Meeting",
        tag: "Strategy",
        color: "#a855f7",
      },
    ],
  };

  const meetings = allData[filter];

  return (
    <Card className="h-100" style={styles.card}>
      {/* Header */}
      <Card.Header style={styles.header}>
        <h5 style={styles.title}>Meetings Schedule</h5>

        {/* Dropdown */}
        <div style={styles.dropdownWrapper}>
          <button
            style={styles.todayBtn}
            onClick={() => setOpen(!open)}
          >
            <FiCalendar size={14} style={{ marginRight: 6 }} />
            {filter}
          </button>

          {open && (
            <div style={styles.dropdown}>
              {["Today", "This Month", "This Year"].map((item) => (
                <div
                  key={item}
                  onClick={() => {
                    setFilter(item);
                    setOpen(false);
                  }}
                  style={{
                    ...styles.dropdownItem,
                    background:
                      filter === item ? "#f97316" : "transparent",
                    color: filter === item ? "#fff" : "#1f2937",
                  }}
                >
                  {item}
                </div>
              ))}
            </div>
          )}
        </div>
      </Card.Header>

      {/* Body */}
      <Card.Body style={styles.body}>
        {/* Timeline */}
        <div style={styles.timeline} />

        {meetings.map((m, i) => (
          <div key={i} style={styles.row}>
            <div style={styles.time}>{m.time}</div>

            <div
              style={{
                ...styles.dot,
                background: m.color,
              }}
            />

            <div style={styles.content}>
              <h6 style={styles.meetingTitle}>{m.title}</h6>
              <span style={styles.tag}>{m.tag}</span>
            </div>
          </div>
        ))}

        {/* Settings */}
        <div style={styles.settings}>
          <FiSettings size={18} />
        </div>
      </Card.Body>
    </Card>
  );
}

/* 🔥 INTERNAL CSS */
const styles = {
  card: {
    border: "2px solid #e6e8ec",
    borderRadius: "5px",
    overflow: "hidden",
    position: "relative",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    background: "#fff",
    borderBottom: "1px solid #eef0f3",
  },

  title: {
    fontSize: "18px",
    fontWeight: "600",
    margin: 0,
  },

  /* Dropdown */
  dropdownWrapper: {
    position: "relative",
  },

  todayBtn: {
    display: "flex",
    alignItems: "center",
    background: "#f3f4f6",
    border: "none",
    fontSize: "13px",
    padding: "6px 12px",
    borderRadius: "6px",
    cursor: "pointer",
  },

  dropdown: {
    position: "absolute",
    top: "40px",
    right: 0,
    width: "160px",
    background: "#fff",
    borderRadius: "10px",
    boxShadow: "0 10px 20px rgba(0,0,0,0.08)",
    padding: "8px 0",
    zIndex: 10,
  },

  dropdownItem: {
    padding: "10px 15px",
    fontSize: "14px",
    cursor: "pointer",
    borderRadius: "6px",
    margin: "2px 6px",
    transition: "0.2s",
  },

  /* Body */
  body: {
    position: "relative",
    padding: "20px",
  },

  timeline: {
    position: "absolute",
    left: "110px",
    top: "20px",
    bottom: "20px",
    width: "2px",
    borderLeft: "2px dotted #e5e7eb",
  },

  row: {
    display: "flex",
    marginBottom: "25px",
    position: "relative",
  },

  time: {
    width: "90px",
    fontSize: "14px",
    color: "#6b7280",
  },

  dot: {
    width: "10px",
    height: "10px",
    borderRadius: "50%",
    position: "absolute",
    left: "105px",
    top: "5px",
  },

  content: {
    marginLeft: "40px",
    background: "#f9fafb",
    padding: "12px",
    borderRadius: "8px",
    width: "100%",
  },

  meetingTitle: {
    fontSize: "14.5px",
    fontWeight: "600",
    marginBottom: "4px",
  },

  tag: {
    fontSize: "13px",
    color: "#6b7280",
  },

  settings: {
    position: "absolute",
    right: "15px",
    top: "70px",
    background: "#f97316",
    color: "#fff",
    width: "36px",
    height: "36px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};